import { formatSearchParam } from "@/utils/formatSearchParam";
import {
  DeepRelationQueryFilter,
  FilterEstablishmentsRequest,
} from "@gurupass/sdk";
import { Query } from "nestjs-prisma-querybuilder-interface";
import { Filter } from "nestjs-prisma-querybuilder-interface";

export interface FilterProps {
  [key: string]: string;
  name: string;
  phone: string;
  cnpj: string;
  city: string;
  modality: string;
  state: string;
  neighborhood: string;
  establishmentIndicationCode: string;
}

interface getEstablishmentsProps {
  page: number;
  filter?: FilterProps;
  establishmentGroupNullable?: boolean;
  limit?: number;
}

const deepRelationFilters = (
  fields?: FilterProps
): DeepRelationQueryFilter[] => {
  const deepRelationFilters: DeepRelationQueryFilter[] = [];

  if (fields?.city) {
    deepRelationFilters.push({
      pathAndOperators: ["city", "name", "equals"],
      value: formatSearchParam(fields.city),
    });
  }

  if (fields?.neighborhood) {
    deepRelationFilters.push({
      pathAndOperators: ["neighborhood", "name", "equals"],
      value: formatSearchParam(fields.neighborhood),
    });
  }

  if (fields?.state) {
    deepRelationFilters.push({
      pathAndOperators: ["city", "state", "name", "equals"],
      value: formatSearchParam(fields.state),
    });
  }

  if (fields?.modality) {
    deepRelationFilters.push({
      pathAndOperators: [
        "modalities",
        "some",
        "modality",
        "some",
        "name",
        "equals",
      ],
      value: formatSearchParam(fields.modality),
    });
  }

  if (fields?.establishmentIndicationCode) {
    deepRelationFilters.push({
      pathAndOperators: ["EstablishmentIndicationCode", "code", "equals"],
      value: formatSearchParam(fields.establishmentIndicationCode),
    });
  }

  return deepRelationFilters;
};

export const getEstablishments = (
  params: getEstablishmentsProps
): FilterEstablishmentsRequest => {
  const filter: Filter = [];

  if (params?.filter?.name) {
    filter.push({
      path: "name",
      operator: "contains",
      value: formatSearchParam(params.filter.name),
      insensitive: true,
    });
  }

  const phone = params?.filter?.phone?.replace(/\D/g, "");
  if (phone) {
    filter.push({
      path: "phone",
      operator: "contains",
      value: formatSearchParam(phone),
    });
  }

  if (params?.filter?.cnpj) {
    filter.push({
      path: "cnpj",
      operator: "equals",
      value: formatSearchParam(params.filter.cnpj),
    });
  }

  return {
    query: {
      select: "id name neighborhood status isFraudulent",
      populate: [
        {
          path: "modalities",
          select: "modality",
          primaryKey: "establishmentId",
        },
        {
          path: "city",
          select: "id name",
          populate: [
            {
              path: "state",
              select: "id name",
            },
          ],
        },
        {
          path: "neighborhood",
          select: "id name",
        },
        {
          path: "EstablishmentIndicationCode",
          select: "id code",
        },
      ],
      filter,
      page: params.page,
      limit: params?.limit ?? 15,
    },
    deepRelationFilters: deepRelationFilters(params.filter),
    avaiableToEstablishmentGroup:
      params.establishmentGroupNullable || undefined,
  };
};

export default getEstablishments;
